import { Fragment } from "react/jsx-runtime"
import welcomePage from "assets/Welcome_Screen.png"

export const HomePageView = () => {
    return (
        <Fragment>
            <div>
                <img src={welcomePage} height={740}/>
            </div>
        </Fragment>
    )
}